import { render, staticRenderFns } from "./noticeLists.vue?vue&type=template&id=6c653cb4&scoped=true&"
import script from "./noticeLists.vue?vue&type=script&lang=js&"
export * from "./noticeLists.vue?vue&type=script&lang=js&"
import style0 from "./noticeLists.vue?vue&type=style&index=0&lang=css&"
import style1 from "./noticeLists.vue?vue&type=style&index=1&id=6c653cb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c653cb4",
  null
  
)

export default component.exports